//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapMutations } from 'vuex'
export default {
  name: 'Kocher_info',
  data() {
    return {}
  },
  components: {},
  created() {
    this.hideLoad()
  },
  methods: {
    ...mapMutations(['hideLoad']),
  },
}



// WEBPACK FOOTER //
// ./src/pages/formulasInfo/Pedi/Kocher_info.vue